<template>
  <div class="parent">
    <p class="title">
      {{ $t(`city_template.steps_title.${normalizeCityName(city)}`) }}
    </p>
    <p class="text">{{ $t('city_template.steps_description') }}</p>
  </div>
</template>

<script>
import normalizeCityName from '@/shared/normalizeCityName';

export default {
  props: ['city'],
  methods: {
    normalizeCityName,
  },
};
</script>

<style scoped>
.parent {
  padding-top: 3em;
  margin: 0 var(--global-open-market-margin);
  text-align: left;
}
.title {
  font: normal normal bold 30px/40px Lato;
  letter-spacing: 0px;
  color: #2b4047;
  margin: 0 auto 1em auto;
}
.text {
  font: normal normal normal 16px/22px Lato;
  letter-spacing: 0px;
  color: #2b4047;
  text-align: left;
}

@media (min-width: 768px) {
  .title {
    font: normal normal bold 40px/80px Lato;
    letter-spacing: 0px;
    color: #2b4047;
    opacity: 1;
    text-align: center;
  }
  .text {
    font-size: 20px;
    text-align: center;
  }
}
</style>
